var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\xE2ngulo_711",
  "data-name": "Ret\xE2ngulo 711",
  width: 24,
  height: 24,
  transform: "translate(17825 15093)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_de_m\xE1scara_158",
  "data-name": "Grupo de m\xE1scara 158",
  transform: "translate(-17825 -15093)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_299",
  "data-name": "Grupo 299",
  transform: "translate(17829 15098.003)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_298",
  "data-name": "Grupo 298"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_479",
  "data-name": "Caminho 479",
  d: "M10.67,13.67a3,3,0,1,1,3-3A3,3,0,0,1,10.67,13.67Zm0-4.961a1.961,1.961,0,1,0,1.961,1.961A1.961,1.961,0,0,0,10.67,8.709Z",
  transform: "translate(-2.67 -3.824)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_480",
  "data-name": "Caminho 480",
  d: "M9.459,16.673C6.6,16.673,3.91,15,2.058,12.1a4.6,4.6,0,0,1,0-4.554c1.86-2.9,4.554-4.569,7.4-4.569S15,4.65,16.852,7.549a4.6,4.6,0,0,1,0,4.554C15,15,12.305,16.673,9.459,16.673Zm0-12.554c-2.452,0-4.8,1.472-6.436,4.046a3.449,3.449,0,0,0,0,3.324c1.639,2.573,3.985,4.046,6.436,4.046s4.8-1.472,6.436-4.046a3.449,3.449,0,0,0,0-3.324C14.256,5.591,11.91,4.118,9.459,4.118Z",
  transform: "translate(-1.455 -2.98)",
  fill: "#db56e0"
}))))));
export default __webpack_public_path__ + "static/media/eye.7c3dd45a.svg";
export { SvgComponent as ReactComponent };